<div class="search-container">
  <div class="row">
    <div class="col-md-12 col-sm-12 default-text show-hide-wrapper">
      <a class="show-hide-link"
         (click)="showHideSearchbar($event)"
         placement="bottom"
         ngbTooltip="{{'info_box.group_details.filter' | translate}}">
        {{'group_details.search_bar.show_hide' | translate}}
      </a>
    </div>
    <div class="col-md-12 col-sm-12">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="d-flex flex-row flex-nowrap">
            <div class="d-flex flex-auto align-items-center">
              <div class="seperate-line"></div>
            </div>
            <div class="d-flex align-items-center">
              <a *ngIf="showSearchBar" class="filter-btn" (click)="clearFilter()">{{'group_details.search_bar.clear_filter' | translate}}</a>
              <a *ngIf="!showSearchBar" class="filter-btn" (click)="showHideSearchbar($event)">{{'group_details.search_bar.open_filter' | translate}}</a>
            </div>
          </div>
        </div>
        <div *ngIf="showSearchBar" class="col-md-12 col-sm-12">
          <div class="d-flex flex-row">
            <div class="group-details-filter-box">
              <achoo-filter-box [options]="countryList" name="searchCountry"
                                [(model)]="groupSearch.selectedCountry"
                                placeholder="{{'group_details.search_bar.country_placeholder' | translate}}"
                                (selectEvent)="searchInfluencers($event, 'Countries')">
              </achoo-filter-box>
            </div>
            <!-- // TODO Filter by gender is not supposed yet. Hide until it's available -->
            <div class="group-details-filter-box" [ngClass]="{'hide-gender-filter': !isCampaignInfluencer}">
              <achoo-filter-box [options]="genderList" name="searchByGender"
                                [(model)]="groupSearch.selectedGender"
                                placeholder="{{'group_details.search_bar.gender_placeholder' | translate}}"
                                (selectEvent)="searchInfluencers($event, 'gender')">
              </achoo-filter-box>
            </div>
            <div class="group-details-filter-box">
              <achoo-filter-box [options]="platFormList" name="searchByPlatform"
                                [(model)]="groupSearch.selectedPlatform"
                                placeholder="{{'group_details.search_bar.platform_placeholder' | translate}}"
                                (selectEvent)="searchInfluencers($event, 'Platforms')">
              </achoo-filter-box>
            </div>
            <div class="group-details-filter-box">
              <div class="single-selected with-icon" [ngClass]="{'has-selected': hasFilterActivity}" (click)="onClickActivityFilters($event)">
                <span class="popup-filter-title" [ngClass]="{'has-selected-filter': hasFilterActivity}">{{'group_details.search_bar.activity' | translate}}</span>
                <img *ngIf="!hasFilterActivity" src="/assets/images/Plus_Dark.svg" class="icon-check">
                <img *ngIf="hasFilterActivity" src="/assets/images/Check_Dark.svg" class="icon-check">
              </div>
              <div class="activity-filters-container" [ngClass]="{'open': showActivityFilter, 'hide': !showActivityFilter}">
                <activity-filters #activityFilter [isActiveDiscoverFollower]="isActiveDiscoverFollower"
                                  (searchInfluencerByActivityEvent)="searchInfluencerByActivity($event)"
                                  (clearActivityFilterEvent)="resetActivityFilters()"
                                  (hideActivityFilterEvent)="onHideActivityFilters($event)">
                </activity-filters>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-4 col-sm-4 light-text search-all">
              <achoo-checkbox name="selectAllInfluencers"
                              [(model)]="checkAll"
                              label="{{'group_details.search_bar.select_all' | translate}}"
                              (selectEvent)="onCheckSelectAll($event)">
              </achoo-checkbox>
            </div>
            <div class="col-md-8 col-sm-8 order-list">
              <div class="d-flex flex-row justify-content-end">
                <div class="order-label">{{'group_details.search_bar.sort_by' | translate}}</div>
                <div *ngIf="isCampaignInfluencer" class="order-btn" [ngClass]="{'active': hasOrderBy('Status')}" (click)="orderInfluencerList('Status')">{{'group_details.search_bar.status' | translate}}</div>
                <div class="order-btn name" [ngClass]="{'active': hasOrderBy('Name')}" (click)="orderInfluencerList('Name')">{{'group_details.search_bar.name' | translate}}</div>
                <div class="order-btn country" [ngClass]="{'active': hasOrderBy('Country')}" (click)="orderInfluencerList('Country')">{{'group_details.search_bar.country' | translate}}</div>
                <div class="order-btn follower" [ngClass]="{'active': hasOrderBy('Reach')}" (click)="orderInfluencerList('Reach')">{{'group_details.search_bar.reach' | translate}}</div>
                <div *ngIf="!isCampaignInfluencer" class="order-btn post" [ngClass]="{'active': hasOrderBy('Engagement')}" (click)="orderInfluencerList('Engagement')">{{'group_details.search_bar.engagement' | translate}}</div>
                <div class="order-btn" [ngClass]="{'active': hasOrderBy('Impact')}" (click)="orderInfluencerList('Impact')">{{'group_details.search_bar.impact' | translate}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/search-bar/search-bar.component.html